/**
 * The shape counsel's documents are flattened into.
 *
 * Deliberately not Markdown. `@elyxeer/ui`'s renderer is a narrow one — headings,
 * bullets and bold — and its own docstring says to replace it with a real parser *and*
 * a sanitiser before asking it for tables or links; the privacy policy opens with a
 * four-column processing table and every document ends in a contact address. A closed
 * set of blocks gives those two things without loosening what article bodies are
 * allowed to contain, and it is what lets the generator assert that the Czech and
 * English files still line up clause for clause.
 */

/** Slugs are public URL segments (`#/legal/privacy`), so they are stable. */
export const LEGAL_SLUGS = ["terms", "privacy", "account-deletion"] as const;

export type LegalSlug = (typeof LEGAL_SLUGS)[number];

export function isLegalSlug(value: string | undefined): value is LegalSlug {
  return (LEGAL_SLUGS as readonly string[]).includes(value ?? "");
}

export type LegalBlock =
  | { kind: "paragraph"; text: string }
  | { kind: "bullets"; items: string[] }
  /** An ordered procedure — "open Settings, then…" — where the order is the content. */
  | { kind: "steps"; items: string[] }
  | { kind: "table"; columns: string[]; rows: string[][] };

export interface LegalSection {
  /**
   * The section number as counsel printed it ("4"), kept apart from the words so it can
   * be set as a label — and so a cross-reference in the prose still resolves against
   * what is on screen. Null for the standfirst, which has no number.
   */
  number: string | null;
  heading: string | null;
  blocks: LegalBlock[];
}

export interface LegalDocument {
  slug: LegalSlug;
  title: string;
  subtitle: string;
  sections: LegalSection[];
}
